import {
  createApp
} from 'vue';
import store from './store';
import vClickOutside from "click-outside-vue3";
import App from './instances/App.vue'
import Search from './instances/Search.vue'
import Product from './instances/Product.vue'
import SearchNav from './instances/SearchNav.vue'
import googleMapCol from './components/search-page/GoogleMap.vue'

const catPage = document.getElementById('app')

if (catPage) {
  const app = createApp(App);
  app.use(store).use(vClickOutside).mount(catPage);
}

const gdSearch = document.getElementById('gdSearch')

if (gdSearch) {
  const banner = createApp(Search);
  banner.use(vClickOutside).mount(gdSearch);
}

const gdSearchNav = document.getElementById('gdSearchNav')

if (gdSearchNav) {
  const nav = createApp(Search, {
    place: 'nav'
  });
  nav.use(vClickOutside).mount(gdSearchNav);
}

const googleMap = document.getElementById('googleMap')

if (googleMap) {
  const product = createApp(Product);
  product.use(store).use(vClickOutside).mount(googleMap);
}

const searchPage = document.getElementById('searchPage')

if (searchPage) {
  const filter = createApp(SearchNav);
  filter.use(store).use(vClickOutside).mount(searchPage);
}

const googleColMap = document.getElementById('googleColMap')

if (googleColMap) {
  const mapCol = createApp(googleMapCol);
  mapCol.mount(googleColMap);
}

